import React, { useContext, useState } from 'react';
import { Button, FormControl, ModalBody, ModalFooter, Table } from 'react-bootstrap';

import { faSearch, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import ModalHeader from 'react-bootstrap/ModalHeader';
import axios from 'axios';
import LoadingSpinner from '../common/LoadingSpinner';
import AuthContext from '../authentication/AuthContext';
import UserContext from '../user/UserContext';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';
import { IconWrapper } from '../common/IconWrapper';
import { useHistory } from 'react-router';

export default function TelesalesSelector(props) {
    const [loading, setLoading] = useState(false);
    const [franchises, setFranchises] = useState([]);
    const [searchString, setSearchString] = useState('');

    const cas = useContext(AuthContext);
    const { userDetails, updateCurrentFranchise } = useContext(UserContext);

    const history = useHistory();

    const searchForFranchises = () => {
        setLoading(true);
        let requestBody = {
            searchString: searchString,
            includeClosed: true,
            maxResults: 100
        };
        axios
            .post(window.CONFIG['ws.activoc-web-order-api.franchises.search'], requestBody, {
                headers: {
                    Authorization: cas,
                    'Content-Type': 'application/json'
                }
            })
            .then(response => {
                setFranchises(response.data);
                setLoading(false);
            });
    };

    const generateTableRows = () => {
        if (franchises.length > 0) {
            return franchises
                .sort((a, b) => a.code - b.code)
                .map(franchise => (
                    <tr
                        onClick={() => {
                            updateCurrentFranchise(franchise);
                            props.close();
                            history.push('/');
                        }}
                        key={franchise.code}
                    >
                        <td>{franchise.code}</td>
                        <td>{franchise.name}</td>
                        <td>{franchise.addressLine2}</td>
                        <td>{franchise.town}</td>
                        <td>{franchise.postcode}</td>
                        <td>{franchise.fascia}</td>
                        <td>{franchise.status}</td>
                    </tr>
                ));
        } else {
            return (
                <tr>
                    <td colSpan={7} className={'telesales-initial-message'}>
                        Please enter search criteria
                    </td>
                </tr>
            );
        }
    };

    return (
        <>
            <ModalHeader closeButton>
                <h2>Retailer Search</h2>
            </ModalHeader>
            <ModalBody>
                <div className={'search-form flex'}>
                    <FormControl
                        type={'search'}
                        placeholder={'Search by Code / Address / Postcode / Order No.'}
                        value={searchString}
                        onChange={e => setSearchString(e.target.value)}
                        onKeyPress={event => {
                            if (event.key === 'Enter') {
                                searchForFranchises();
                            }
                        }}
                    />
                    <Button type={'primary'} onClick={searchForFranchises} title={'Search'}>
                        <IconWrapper icon={faSearch} />
                        Search
                    </Button>
                </div>
                <Table hover={franchises.length > 0}>
                    <thead>
                        <tr>
                            <th>Code</th>
                            <th>Name</th>
                            <th>Address</th>
                            <th>Town</th>
                            <th>Postcode</th>
                            <th>Fascia</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr>
                                <td colSpan={7}>
                                    <LoadingSpinner />
                                </td>
                            </tr>
                        ) : (
                            generateTableRows()
                        )}
                    </tbody>
                </Table>
            </ModalBody>
            <ModalFooter>
                {userDetails.currentFranchise ? (
                    <Button variant={'secondary'} onClick={props.close}>
                        <IconWrapper icon={faTimesCircle} />
                        Cancel
                    </Button>
                ) : (
                    <Button className={'logout'} onClick={props.logout}>
                        <IconWrapper icon={faSignOutAlt} />
                        Logout
                    </Button>
                )}
            </ModalFooter>
        </>
    );
}
